// extracted by mini-css-extract-plugin
module.exports = {"title":"Report_title__1kc0e","text":"Report_text__1cERk","info":"Report_info__jEhaV","input":"Report_input__25N7b","btns":"Report_btns__2PYb2","button":"Report_button__1cR7e"};